<div @fade class="container-signin-2">
  <header class="header">
    <div class="container-logo">
      <div class="logo">
        <img (click)="goToUrl()" src="./assets/temporals/Logo_Akana_Azul.png" alt="">
      </div>
    </div>
  </header>
  <router-outlet></router-outlet>
  <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>
